module.exports = __webpack_public_path__ + "img/fira-image-c.dff8ad51.png";